// extracted by mini-css-extract-plugin
export default {"navbar_btn":"Navbar_navbar_btn__d-QAM"};